/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {
    IStillImageBgIntroViewConfig,
    StillImageBgIntroView
} from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {DirtyWildsGameAssets} from "../DirtyWildsGameAssets";
import {TweenMax, Linear} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class DirtyWildsIntroView extends StillImageBgIntroView {

    //private _text:PIXI.Text;
    private _logo:PIXI.Sprite;
    private _mayanMystery:PIXI.Sprite;
    private _mayanWilds:PIXI.Sprite;
    private _features:PIXI.Sprite[];
    private _gfxContainer:PIXI.Container;

    constructor(config:IStillImageBgIntroViewConfig) {
        super(config);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._features = [];
        this._gfxContainer = new PIXI.Container();
        this._logo = new PIXI.Sprite(GameResources.getTextures(DirtyWildsGameAssets.INTRO_LOGO)[0]);
        this._logo.anchor.set(0.5, 0);
        this._mayanWilds = new PIXI.Sprite(GameResources.getTextures(DirtyWildsGameAssets.MAYAN_WILD)[0]);
        this._mayanWilds.anchor.set(0.5, 0.5);
        this._mayanMystery = new PIXI.Sprite(GameResources.getTextures(DirtyWildsGameAssets.MAYAN_MYSTERY)[0]);
        this._mayanMystery.anchor.set(0.5, 0.5);
        this._features.push(this._mayanWilds);
        this._features.push(this._mayanMystery);
        //this._text = new PIXI.Text("Some text on the intro?", {fill : 0xffffff, fontSize : 80});
        //this._text.anchor.set(0.5, 0);


        this._gfxContainer.addChild(this._logo);
        this._gfxContainer.addChild(this._mayanWilds);
        this._gfxContainer.addChild(this._mayanMystery);

        //this._gfxContainer.addChild(this._text);

        return this._gfxContainer;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        let heightMultiplier:number = 0.4;
        let offsetMultiplier:number = 4;
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._gfxContainer.position.set(this._screenWidth / 2, 0);
            this._logo.scale.set(1);
            this._gfxContainer.position.set(this._screenWidth / 2, this._screenHeight * 0.3);
            heightMultiplier = 0.2;
            offsetMultiplier = 3.3;
        }
        else {
            this._logo.scale.set(0.6);
            this._gfxContainer.position.set(this._screenWidth / 2, this._screenHeight * 0.1);
        }

        const maxHeight:number = MathHelper.roundToDecimals(this._screenHeight * 0.5, 2);
        const maxWidth:number = MathHelper.roundToDecimals(this._screenWidth * 0.4, 2);
        let scaleX:number;
        let scaleY:number;
        this._features.forEach((feature:PIXI.Sprite, index:number) => {
            scaleX = scaleX == null ? maxWidth / feature.texture.width : Math.min(scaleX, maxWidth / feature.texture.width);
            scaleY = scaleY == null ? maxHeight / feature.texture.height : Math.min(scaleY, maxHeight / feature.texture.height);
        });
        const scale:number = MathHelper.roundToDecimals(Math.min(scaleX!, scaleY!), 2);
        let totalWidth:number = 0;
        this._features.forEach((feature:PIXI.Sprite, index:number) => {
            feature.scale.set(scale);
            totalWidth += feature.width;
        });
        const offsetX:number = MathHelper.roundToDecimals(Math.min(this._features[1].width, Math.max(0, (this._screenWidth - totalWidth) / offsetMultiplier)) + this._features[0].width / offsetMultiplier + this._features[1].width / offsetMultiplier, 2);
        this._mayanWilds.position.set(-offsetX, this._screenHeight * heightMultiplier);
        this._mayanMystery.position.set(offsetX, this._screenHeight * heightMultiplier);

    }
}